var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.52,13.93c2.77,0,3.8-1,4.16-1.36,0,0,.32-.31.32-.57a1.09,1.09,0,0,0-.32-.58c-.36-.33-1.39-1.35-4.16-1.35H14.9L9.45.74A1,1,0,0,0,8.67.26H6.72L9.6,10.07H7.92a18.23,18.23,0,0,0-3.18.32L2.83,7.87A1.2,1.2,0,0,0,2,7.37H0l1.43,3.75a2.69,2.69,0,0,0-1.32.82h0a.07.07,0,0,0,0,.06s0,0,0,.06h0a2.84,2.84,0,0,0,1.32.83L0,16.63H2a1.19,1.19,0,0,0,.88-.51h0l1.91-2.51a20.39,20.39,0,0,0,3.18.32h1.7L6.71,23.74h2a1,1,0,0,0,.78-.48l5.45-9.33h4.62Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.4e72da2a.svg";
export { ForwardRef as ReactComponent };